'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialSecurity = function SocialSecurity(_ref) {
  var number = _ref.number,
      props = (0, _objectWithoutProperties3.default)(_ref, ['number']);
  return _react2.default.createElement(
    _text2.default,
    props,
    SocialSecurity.format(number, props)
  );
};

SocialSecurity.format = function formatSocialSecurityNumber(number) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$showFull = _ref2.showFull,
      showFull = _ref2$showFull === undefined ? false : _ref2$showFull;

  return showFull ? number.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3') : '***-**-' + number.slice(-4);
};

SocialSecurity.displayName = 'hui:SocialSecurity';
SocialSecurity.huiName = 'SocialSecurity';

SocialSecurity.propTypes = {
  number: _propTypes2.default.string.isRequired
};

exports.default = SocialSecurity;
//# sourceMappingURL=SocialSecurity.js.map


//////////////////
// WEBPACK FOOTER
// ../social-security/lib/SocialSecurity.js
// module id = 754
// module chunks = 0